// extracted by mini-css-extract-plugin
export default {"productDescription":"oda-z","featuredDescription":"pda-z","description":"qda-z","more":"rda-z","descriptionSku":"sda-z"};